/*=========================================================================================
  File Name: moduleTodoMutations.js
  Description: Todo Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_USER_COURSES (state, query) {
      state.userCourses = query
    },
    SET_USER_COURSES_COUNT (state, query) {
      state.count = query
    },
    SET_COURSES (state, query) {
      state.courses = query
    },
    SET_ALLUSERS (state, query){
      state.allUsers = query
    }
  }
  